// pages/qna/QnAPage.tsx
import React, {useEffect, useState} from 'react';
import {useNavigate} from 'react-router-dom';
import {getQnAList, QnAListItemDto} from '../../api/deskApi';

const QnAPage = () => {
    const navigate = useNavigate();
    const [qnaList, setQnaList] = useState<QnAListItemDto[]>([]);
    const [isLoading, setIsLoading] = useState(true);

    useEffect(() => {
        fetchQnAList();
    }, []);

    const fetchQnAList = async () => {
        try {
            setIsLoading(true);
            const response = await getQnAList();


            if (response.data?.code === "00" && response.data.data) {
                setQnaList(response.data.data);
            } else {
                console.error('리스트 조회 실패:', response.data?.message);
            }
        } catch (error) {
            console.error('Q&A 리스트 조회 오류:', error);
            alert('문의 목록을 불러오는 중 오류가 발생했습니다.');
        } finally {
            setIsLoading(false);
        }
    };

    // 상태 표시 변환
    const getStatusText = (status: string) => {
        switch (status) {
            case 'PENDING':
                return '접수';
            case 'PROCESSING':
                return '처리중';
            case 'COMPLETED':
                return '완료';
            default:
                return status;
        }
    };

    // 날짜 포맷 변환 (2025-01-01T12:00:00 -> 2025.01.01)
    const formatDate = (dateString: string) => {
        if (!dateString) return '';
        return dateString.split('T')[0].replace(/-/g, '.');
    };

    if (isLoading) {
        return (
            <>
                <div className="bottom-btn">
                    <button
                        type="button"
                        className="btn confirm"
                        onClick={() => navigate('/desk/qna/write')}
                    >
                        1:1 문의 하기
                    </button>
                </div>
                <main className="container type_gray">
                    <div className="inner-box">
                        <p style={{textAlign: 'center', padding: '50px 0'}}>로딩 중...</p>
                    </div>
                </main>
            </>
        );
    }

    return (
        <>
            <div className="bottom-btn">
                <button
                    type="button"
                    className="btn confirm"
                    onClick={() => navigate('/desk/qna/write')}
                >
                    1:1 문의 하기
                </button>
            </div>

            <main className="container type_gray">
                <div className="inner-box">
                    {qnaList.length === 0 ? (
                        <div style={{textAlign: 'center', padding: '50px 0', color: '#999'}}>
                            등록된 문의가 없습니다.
                        </div>
                    ) : (
                        qnaList.map((item) => (
                            <div key={item.qnaCode} className="round-box">
                                <div className="round-body">
                                    <div className="inquiry-box">
                                        <div
                                            onClick={() => navigate(`/desk/qna/${item.qnaCode}`)}
                                            style={{cursor: 'pointer'}}
                                        >
                                            <p className="txt">
                                                <span className="color">Q.</span>
                                                {item.questionTitle}
                                            </p>
                                            <p className="date">{formatDate(item.regDate)}</p>
                                        </div>
                                        <div className={`status ${item.status === 'COMPLETED' ? 'on' : ''}`}>
                                            {getStatusText(item.status)}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        ))
                    )}
                </div>
            </main>
        </>
    );
};

export default QnAPage;